import React from "react";
import { Helmet } from "react-helmet";

export default function Meta({title, metaDescription, metaTitle, metaKeywords}) {
  return (
    <Helmet>
      <title>{title ? title : 'Search Education Report'}</title>
      <meta name="theme-color" content="#f36525" />
    </Helmet>
  );
}
